import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EsItemBeforeList from '../../components/es/EsItemBeforeList';
import { reqEsItemListAction, resetItemStatus, reqEsItemListBeforeAction, reqEsItemListBeforeAddAction} from '../../modules/es/esItemModule';
import styled from 'styled-components';
import CheckBtn from '../../components/common/button/CheckBtn';
import {isMobileOnly} from 'react-device-detect';
import NormalSmallBtn from '../../components/common/button/NormalSmallBtn';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';

const EstimateBeforeListHeaderBlock = styled.div`
    ${isMobileOnly?`
    ''   
    `:`
    
    `};
    height: 60px;
    padding: 17px 0px;
    margin-bottom: 10px;
`;

const EstimateBeforeListHeaderCheckBlock = styled.div`
    float : left;
    margin-top: -4px;
`;
const EstimateBeforeListHeaderSpanBlock = styled.span`
    ${isMobileOnly?`
    font-size: 14px;
    line-height: 26px;   
    `:`
    font-size: 16px;
    `};
    float : left;
    margin-left : 10px;
    
    font-weight: normal;
    text-align: left;
    color: #333333;
`;

const EstimateListBeforeHeaderBlock = styled.div`
    ${isMobileOnly?`
    margin: 0 4vw; 
    height: 33px;
    //padding: 17px 0px;
    //padding-top: 30px;  
    `:`
    border-bottom: solid 2px #111111;
    height: 140px;
    padding: 17px 0px;
    padding-top: 95px;
    `};
`;
const EstimateListBeforeHeaderDelBlock = styled.div`
    ${isMobileOnly?`
    margin: 0 4vw; 
    height: 60px;
    padding: 18px 0px; 
    `:`
    height: 60px;
    padding: 18px 0px;
    `};
    display: ${props => props.display};
`;

const EstimateListBeforeHeaderCheckBlock = styled.div`
    float : left;
    margin-top: -4px;
    display: ${props => props.display};
    margin-right: 10px;
`;
const EstimateListBeforeHeaderSpanBlock = styled.span`
    ${isMobileOnly?`
    font-size: 16px;
    line-height: 26px;   
    `:`
    font-size: 18px;
    `};
    float : left;
    //margin-left : 10px;
    
    font-weight: 500;
    text-align: left;
    color: #111111;
`;
const EstimateListBeforeHeaderDelSpanBlock = styled.span`
    ${isMobileOnly?`
    font-size: 14px;
    line-height: 26px;   
    `:`
    font-size: 16px;
    `};
    float : left;
    //margin-left : 10px;
    
    font-weight: normal;
    text-align: left;
    color: #333333;
`;
const EstimateListBeforeMoreBlock = styled.p`
    text-align: center;
`;

const EstimateListBeforeMoreBtnBlock = styled.button`
    text-align: center;
    color: #111;
    font-size: 14px;
    text-decoration: underline;
    margin-top: 40px;
`;

const EsItemsListContainer = ({ curIdx, handleBeforeAllCheckClick, handlleBeforeCheckClick, handleDeleteBeforeItem, handleDeleteStatus, delStatus }) => {

    const dispatch = useDispatch();
    const history = useHistory();
    //const [delStatus, setDelStatus] = useState(false);

    const { esListBeforeResult, esItemsBefore, error, loading, accessToken, esItemCheckBefore } = useSelector(
        ({ esItemsReducer, loadingReducer, userReducer }) => ({
            esListBeforeResult: esItemsReducer.esListBeforeResult,
            esItemsBefore: esItemsReducer.esItemsBefore,
            error: esItemsReducer.error,
            loading: loadingReducer['esitem/LIST_ES_BEFORE'],
            accessToken: userReducer.accessToken,
            esItemCheckBefore: esItemsReducer.esItemCheckBefore,
        })
    );

    useEffect(() => {
        if (accessToken !== null) {
            //dispatch(reqEsItemListAction("type=0&sort=0"));
            
            if(history.action !== 'POP' || esItemsBefore === null){
                dispatch(reqEsItemListBeforeAction());
            } 
        }

    }, []);

    useEffect(() => {
        if (accessToken !== null && esListBeforeResult === null) {
            //dispatch(reqEsItemListAction("type=0&sort=0"));
            dispatch(reqEsItemListBeforeAction());
        } else if (esListBeforeResult === 600) {
            dispatch(resetItemStatus());
        }

    }, [accessToken, esListBeforeResult]);

    const handleDelCheckClick = (value) => {
        handleBeforeAllCheckClick(value);
    }

    const handleCheckDeleteBtnClick = (value) => {
        handleDeleteStatus(!delStatus);
        //setDelStatus(!delStatus);
        
      // 팝업 표시
      // % 브랜드 % 의 상품들을 모두 삭제하시겠습니까 ?
      /* if(prodCartCheckInfo !== null && prodCartCheckInfo.length > 0) {
          setKind(0);
          setMsg1("");
          setMsg2("선택된 상품들을 삭제하시겠습니까?");
          setMsg3("");
          setOpenModal(true);
      } */
  }

    // 체크 상태 확인
    const getDelCheckStatus = () => {
        let ret = true;

        if(esItemsBefore === null || esItemsBefore === undefined || esItemsBefore.items.length < 1) {
            return false;
        }

        return esItemsBefore.items.length === esItemCheckBefore.length;
    }

    const isMoreBtnShow = () => {
        //return true;
        if (esItemsBefore === null ||
            esItemsBefore.totalcount === 0 ||
            esItemsBefore.totalcount <= esItemsBefore.items.length) {
            return false;
        }

        return true;
    }

    const handlerMoerClick = () => {
        let count = esItemsBefore.items.length*1;
        //console.log('count = ' + count);
        dispatch(reqEsItemListBeforeAddAction(count.toString()));
    }

    if (loading || esItemsBefore === undefined || esItemsBefore === null || esItemsBefore.items === null || esItemsBefore.items === undefined  || esItemsBefore.totalcount < 1) {
        return <div />
    }

    return (
    <div>
        <EstimateListBeforeHeaderBlock>
            {/* <EstimateListBeforeHeaderCheckBlock display={delStatus? 'block':'none'}>
                    <CheckBtn onClick={handleDelCheckClick} defaultValue={getDelCheckStatus()}/>
                </EstimateListBeforeHeaderCheckBlock> */}
                <EstimateListBeforeHeaderSpanBlock>이전 견적서</EstimateListBeforeHeaderSpanBlock>
            
                <NormalSmallBtn float="right" marginBottom={isMobileOnly ? "0px":"20px"} marginTop="-10px"
                        display='inline-block'
                        bgColor='transparent'
                        textColor="#999" fontSize={isMobileOnly ? "12px":"14px"} fontWeight="300"
                        width='fit-content'
                        text={delStatus? "취소":"선택삭제"} onClick={handleCheckDeleteBtnClick} />
                        
        </EstimateListBeforeHeaderBlock>
        <EstimateListBeforeHeaderDelBlock display={delStatus? 'block':'none'}>
            <EstimateListBeforeHeaderCheckBlock display={delStatus? 'block':'none'}>
                <CheckBtn onClick={handleDelCheckClick} defaultValue={getDelCheckStatus()}/>
            </EstimateListBeforeHeaderCheckBlock>
            <EstimateListBeforeHeaderDelSpanBlock>모두선택</EstimateListBeforeHeaderDelSpanBlock>
        </EstimateListBeforeHeaderDelBlock>
        
            
        <EsItemBeforeList
        loading={loading}
        accessToken={accessToken}
        esItems={esItemsBefore.items}
        curIdx={curIdx}
        delStatus={delStatus}
        handlleBeforeCheckClick={handlleBeforeCheckClick}
         handleDeleteBeforeItem={handleDeleteBeforeItem} 
        />

        {isMoreBtnShow() ?
            <EstimateListBeforeMoreBlock>
                <EstimateListBeforeMoreBtnBlock onClick={handlerMoerClick}>더보기
            </EstimateListBeforeMoreBtnBlock>
            </EstimateListBeforeMoreBlock> : ''
        }

    </div>
        

    )

}

export default EsItemsListContainer;